import UiElement from '../../../shared/ui-element/ui-element';
import Logger from '../../utils/logger/logger';
import CookieBanner from '../../components/cookie-banner/cookie-banner';
import SignupModal from '../../components/signup-modal/signup-modal';
import Carousel from '../../components/carousel/carousel';
import breakpoints from '../../config/breakpoints';

import '../../main.scss';
import './partners.scss';

class PartnerPage extends UiElement {
  constructor() {
    super();

    this.signupModal = new SignupModal();
    this.initSignUpButtons();
  }

  ui = {
    testimonialsCarousel: '.js-testimonials-carousel',
  };

  onInit() {
    Logger.initialize();
    new CookieBanner().init();

    this.signupModal.init();

    this.testimonialsCarousel = new Carousel({
      rootElement: this.ui.testimonialsCarousel,
      slidesPerPage: {
        [breakpoints.sm]: 2,
        [breakpoints.lg]: 3,
      },
    }).init();
  }

  initSignUpButtons() {
    const buttons = document.querySelectorAll('[data-signup-button]');

    [].forEach.call(buttons, (button) => {
      button.addEventListener('click', this.handleSignUpButtonClick);
    });
  }

  handleSignUpButtonClick = (e) => {
    const { campaign } = e.currentTarget.dataset;

    this.signupModal.open({ campaign });
  };
}
export default PartnerPage;

PartnerPage.initOnDomLoaded();
